import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { i18nextPlugin } from 'translation-check'

import de from './assets/i18n/de.json'
import en from './assets/i18n/en.json'

const resources = {
  en: {
    translation: {
      ...en,
    },
  },
  de: {
    translation: {
      ...de,
    },
  },
}

const defaultLanguage = 'en'
const supportedLanguages = ['en', 'de']

const getInitialLanguage = (): string => {
  try {
    const savedLanguage = localStorage.getItem('i18nextLng')
    if (savedLanguage && supportedLanguages.includes(savedLanguage)) {
      return savedLanguage
    }
  } catch (error) {
    console.warn('Failed to read language from localStorage:', error)
  }

  const browserLanguage = navigator.language.split('-')[0]
  if (browserLanguage && supportedLanguages.includes(browserLanguage)) {
    return browserLanguage
  }

  return defaultLanguage
}

const i18nInstance = i18n.use(initReactI18next)
if (import.meta.env.DEV) {
  i18nInstance.use(i18nextPlugin)
}
i18nInstance.init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: defaultLanguage,
  supportedLngs: supportedLanguages,
  interpolation: {
    escapeValue: false,
  },
})

i18nInstance.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('i18nextLng', lng)
  } catch (error) {
    console.warn('Failed to save language to localStorage:', error)
  }
})

export default i18n
